// Centralized formatting + default deal data
export const fmtCurrency = (n, opts = {}) => {
  const num = Number(n || 0);
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: opts.cents === false ? 0 : 2,
    maximumFractionDigits: 2,
  });
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
};

export const numberToWords = (num) => {
  // Simple integer-to-words for dollar amounts up to billions
  const a = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const inWords = (n) => {
    if (n === 0) return "Zero";
    let str = "";
    const scales = [
      [1_000_000_000, "Billion"],
      [1_000_000, "Million"],
      [1_000, "Thousand"],
      [100, "Hundred"],
    ];
    for (const [val, name] of scales) {
      if (n >= val) {
        str += inWords(Math.floor(n / val)) + " " + name + " ";
        n = n % val;
      }
    }
    if (n > 0) {
      if (n < 20) str += a[n];
      else {
        str += b[Math.floor(n / 10)];
        if (n % 10) str += "-" + a[n % 10];
      }
    }
    return str.trim();
  };
  const dollars = Math.floor(Number(num || 0));
  const cents = Math.round((Number(num || 0) - dollars) * 100);
  let out = inWords(dollars) + " Dollars";
  if (cents > 0) out += " and " + inWords(cents) + " Cents";
  else out += " and Zero Cents";
  return out;
};

export const defaultDeal = {
  // ── Party 1: TREASURY HOUSE TRUST (the only first-party in every document) ──
  // The Trust is the Issuer / Maker / Seller / Drawer / Borrower in all paths.
  // Its operating address is used throughout.
  borrowerName: "TREASURY HOUSE TRUST",
  borrowerState: "Tennessee",
  borrowerCity: "Memphis",
  borrowerAddress: "3150 E. Shelby Dr, Memphis, TN 38118",
  signerName: "Thomas Franklin",
  signerTitle: "Managing Trustee · Treasury House Trust",
  secretaryName: "Avery L. Pennington",
  trusteeName: "Thomas Franklin",
  trusteeTitle: "Managing Trustee",
  cotrusteeName: "Avery L. Pennington",
  cotrusteeTitle: "Independent Co-Trustee",

  // ── Party 2: COUNTERPARTY ──
  // To be designated per-deal — no default bank or beneficiary.
  lenderName: "",
  lenderAddress: "",
  lenderBankName: "",
  lenderRouting: "",
  lenderAccount: "",
  lenderAccountRef: "",
  lenderOfficer: "",

  // Maker of the underlying Subject Note — Medcare originator (3150 E. Shelby
  // Dr., Memphis, TN 38118). The chain-of-title shows Medcare → THT → Counterparty.
  makerName: "COMMERCIAL BANCORP HOLDINGS",
  makerAddress: "3150 E. Shelby Dr, Memphis, TN 38118",
  originatorName: "MEDCARE NURSING INSTITUTE & TRAINING ACADEMY",
  originatorAddress: "3150 E. Shelby Dr, Memphis, TN 38118",

  // Buyer — TBD until counterparty commits to the deal
  buyerName: "TO BE DESIGNATED",
  buyerAddress: "",
  buyerSigner: "",
  buyerTitle: "Authorized Officer",

  // Dates
  executionDate: "2026-05-27",
  maturityDate: "2027-05-27",
  saleClosingDate: "2026-05-27",

  // Financing
  loanPrincipal: 80000,
  loanRate: 8.0,

  // Underlying instrument
  faceValue: 100000,
  couponRate: 6.0,
  termDays: 365,

  // Discount sale
  purchasePrice: 80000,

  // Acceptance / Treasury — TBD per deal (no default bank)
  acceptanceBankName: "",
  acceptanceDeskAddress: "",
  acceptanceOfficer: "",
  acceptanceOfficerTitle: "",
  treasuryHouseName: "Treasury House Trust",
  treasuryHouseTagline: "Discount Series · UCC § 3-104",

  // ── SPV Trust formation (self-declared; no external settlor party) ──
  trustName: "TREASURY HOUSE TRUST",
  trustEIN: "92-3447801",
  trustJurisdiction: "Tennessee",
  trustExecutionDate: "2026-06-19",
  // Trust banking — TBD per deal
  trustSettlor: "Thomas Franklin, as Settlor-Trustee",
  trustBeneficiary: "Holders of Class A Beneficial-Interest Certificates of the Trust",
  trustBankName: "",
  trustAccountNumber: "",
  beneficialOwnerName: "Thomas Franklin",
  beneficialOwnerPct: "100%",

  // Custody / Bailee — TBD per deal (no default custodian bank)
  custodianName: "",
  custodianAddress: "",
  custodianOfficer: "",
  custodianOfficerTitle: "",
  custodyAccountNumber: "",
  custodyFee: "",

  // Proceeds Direction — counterparty TBD per deal
  proceedsRecipient: "trustee",
  proceedsPurpose: "General Trust working capital and operating reserve",
  counterpartyName: "TO BE DESIGNATED",
  counterpartyAddress: "",
  counterpartyRole: "Counterparty (TBD)",
  counterpartyBankName: "",
  counterpartyRouting: "",
  counterpartyAccount: "",
  counterpartyPurpose: "",

  // Opinion of Counsel (Beale & Drape LLP) — signing partner on Doc T-06
  counselFirmName: "Beale & Drape LLP",
  counselSignatoryName: "Christopher Philps, Esq.",
  counselSignatoryTitle: "Partner",

  // Misc
  governingLaw: "Tennessee",
  jurisdiction: "Shelby County, Tennessee",
};
